// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"jn-z","badgeLink":"kn-z","category":"ln-z"};